import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCheckmark1Medium"><Path d="M6 14.15L10.0321 18L18 7" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCheckmark1Medium;
